import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api/http";
import { useStore } from "../store/useStore";
import { akzentVariablen, istAkzent, wendeAkzentAn } from "../lib/kommune";
import { setzeChartAkzent } from "../lib/chartAkzent";

/**
 * Welches Projekt gibt gerade die Farbe vor? Die Adresse geht vor (Dashboard,
 * Meldeportal, Karte), sonst das zuletzt genutzte Projekt — so traegt auch die
 * Verwaltung die Farbe der Kommune, an der man gerade arbeitet.
 */
function aktivesProjekt(pathname: string, search: string, zuletzt: string | null | undefined): string | null {
  const pfad = /^\/(?:project|meldeportal)\/([^/]+)/.exec(pathname);
  if (pfad?.[1]) return decodeURIComponent(pfad[1]);
  if (pathname.startsWith("/karte")) {
    const p = new URLSearchParams(search).get("project");
    if (p) return p;
  }
  return zuletzt ?? null;
}

/**
 * Legt die Akzentfarbe der aktiven Kommune auf die Oberflaeche (lib/kommune.ts).
 * Die oeffentliche Meldeseite setzt ihre Farbe selbst — sie kennt kein Konto.
 */
export function KommunenAkzent() {
  const auth = useStore((s) => s.auth);
  const theme = useStore((s) => s.theme);
  const zuletzt = useStore((s) => s.lastProjectId);
  const { pathname, search } = useLocation();
  const projectsQ = useQuery({ queryKey: ["projects"], queryFn: () => api.projects.list(), enabled: !!auth });
  const oeffentlich = pathname.startsWith("/melden/");
  const id = aktivesProjekt(pathname, search, zuletzt);
  const farbe = auth ? (projectsQ.data?.find((p) => p.id === id)?.akzentfarbe ?? null) : null;

  useEffect(() => {
    if (oeffentlich) return;
    wendeAkzentAn(farbe, theme === "dark");
    // Diagramme (Issue #127): hell die Knopffarbe, dunkel die lesbare Schriftfarbe
    setzeChartAkzent(istAkzent(farbe) ? { hell: akzentVariablen(farbe, false)["--accent"]!, dunkel: akzentVariablen(farbe, true)["--accent-text"]! } : null);
  }, [farbe, theme, oeffentlich]);

  return null;
}
